/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Resource } from '../../models/resource';
import { ResourceDto } from '../../models/resource-dto';

export interface ResourceControllerCreateResource$Params {
  alwaysAllowActor: boolean;
      body: ResourceDto
}

export function resourceControllerCreateResource(http: HttpClient, rootUrl: string, params: ResourceControllerCreateResource$Params, context?: HttpContext): Observable<StrictHttpResponse<Resource>> {
  const rb = new RequestBuilder(rootUrl, resourceControllerCreateResource.PATH, 'post');
  if (params) {
    rb.path('alwaysAllowActor', params.alwaysAllowActor, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Resource>;
    })
  );
}

resourceControllerCreateResource.PATH = '/resources/{alwaysAllowActor}';
